import React, { useCallback, useEffect, useState } from "react";
import "./StoreHeader.scss";
import { t } from "@lingui/core/macro";
import { translate } from "@Src/components/Translation";
import { i18n } from "@lingui/core";

function StoreHeader({ storeInfo, location, hideStoreInfo, hideStoreDescription }) {
  const { logo_url, name } = storeInfo;
  const { description } = location;
  const [isTruncated, setIsTruncated] = useState(true);
  const [showTruncateButton, setShowTruncateButton] = useState(false);
  const [doCheckDescription, setDoCheckDescription] = useState(false);
  const [translatedDescription, setTranslatedDescription] = useState("");

  useEffect(() => {
    function handleResize() {
      setDoCheckDescription(true);
    }

    window.addEventListener("resize", handleResize);
    translate(description, i18n._locale, setTranslatedDescription);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [description]);

  const descriptionRefCallback = useCallback(
    (node) => {
      if (!!node) {
        const shouldShowTruncateButton = node.scrollHeight > getLineHeight(node) * 2;

        if (shouldShowTruncateButton !== showTruncateButton) {
          setShowTruncateButton(shouldShowTruncateButton);
        }

        if (doCheckDescription) setDoCheckDescription(false);
      }
    },
    // description is needed since it contributes to description node height
    // eslint doesn't like it being in dependency array if it's not used in callback
    [doCheckDescription, translatedDescription], // eslint-disable-line
  );

  const getLineHeight = (current) =>
    getComputedStyle(current).getPropertyValue("line-height").replace("px", "");

  function toggleTruncated() {
    setIsTruncated(!isTruncated);
  }

  if (hideStoreInfo) return null;
  return (
    <div className="store-info">
      <img className="store-info__logo" src={logo_url} alt={name} />
      <div className="store-info__container">
        <h2 className="store-info__name t-title-large">
          <span dangerouslySetInnerHTML={{ __html: name }} />
        </h2>
        {!hideStoreDescription && translatedDescription && (
          <>
            <div
              className={`store-info__description t-body-med ${isTruncated ? "truncated" : ""}`}
              ref={descriptionRefCallback}
            >
              <div dangerouslySetInnerHTML={{ __html: translatedDescription }} />
            </div>
            <div className="store-info__truncate-wrapper">
              {showTruncateButton && (
                <button
                  className="store-info__truncate"
                  onClick={toggleTruncated}
                  aria-expanded={!isTruncated}
                >
                  <span className="t-label-med">{isTruncated ? t`Read more` : t`Read less`}</span>
                </button>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default StoreHeader;
